module.exports = __webpack_public_path__ + "static/logo-undefined-264404130a9c10aa9a744921cc3d87aa.png";